import httpClient from "./httpClient";

const PLATFORM = "spotify";

const getAllGenres = () => httpClient.get(`${PLATFORM}/all-genres`);

export { getAllGenres };
